class LLDSProductGallery {
    constructor() {
        document.querySelectorAll('.product-gallery__media').forEach(el => {
            el.addEventListener('click', this.expandGallery);
        });
        document.querySelectorAll('.product-gallery__thumbnails').forEach(el => {
            el.addEventListener('click', this.handleThumbnailClick);
        });
    }

    expandGallery() {
        const mainGrid = document.querySelector('.main-product__grid');
        const productGallery = document.querySelector('.product-gallery');
        if (mainGrid) {
            mainGrid.classList.toggle('main-product__grid--expanded');
        }
        if (productGallery) {
            productGallery.classList.toggle('product-gallery--expanded');
        }

        document.querySelectorAll('.product-gallery__media').forEach(el => {
            el.classList.toggle('product-gallery__media--expanded');
        });
    }
    handleThumbnailClick(event) {
        const thumbnail = event.target.closest('.product-gallery__thumbnail');
        if (thumbnail) {
            const mediaId = thumbnail.getAttribute('data-media-id');
            const mainMedia = document.querySelector(`.product-gallery__media[data-media-id="${mediaId}"]`);
            if (mainMedia) {
                mainMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });
                mainMedia.click();
            }
        }
    }
}

new LLDSProductGallery();
